<template>
  <div class="">
    <modal-yield-playgrounds
      v-if="showYieldPlayground"
      :showModal="showYieldPlayground"
      :yieldSettings="yieldSettingsState.yieldSettings"
      :onClickCancel="closeEditModal"
    />

    <section class="is-small">
      <div class="container">
        <nav class="navbar mb-4">
          <a
            @click="$router.go(-1)"
            class="navbar-item"
          >
            <span class="icon is-small">
              <font-awesome-icon :icon="['fas', 'chevron-left']" />
            </span>
            <span>Back</span>
          </a>
        </nav>

        <div
          v-if="yieldSettingsState.yieldSettings"
          class="actionBar has-background-white-ter has-padding has-margin-bottom"
        >
          <div class="level">
            <div class="level-left"></div>
            <div class="level-right">
              <a
                @click="setShowYieldPlayground"
                class="has-icon"
              >
                <span class="icon">
                  <font-awesome-icon
                    :icon="['fas', 'edit']"
                    aria-hidden="true"
                  />
                </span>
                <span>Open playground</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section
      v-if="yieldSettingsState.yieldSettings"
      class="is-small"
    >
      <YieldPrices class="container" />
    </section>

    <section
      v-if="yieldSettingsState.yieldSettings"
      class="is-small"
    >
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="box">
              <yield-location-utilization />
            </div>
          </div>
          <div class="column">
            <div class="box">
              <yield-space-utilization />
            </div>
          </div>
        </div>

        <div
          v-if="yieldSettingsState.yieldSettings"
          class="columns"
        >
          <div class="column">
            <div class="box">
              <yield-day-percentages />
            </div>
          </div>
          <div class="column">
            <div class="box">
              <yield-group-sizes />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import locationProvider from '@/providers/location'
import yieldProvider from '@/providers/yield'

const YieldDayPercentages = () => import('@/components/Yield/DayPercentages')
const YieldGroupSizes = () => import('@/components/Yield/GroupSizes')
const YieldLocationUtilization = () =>
  import('@/components/Yield/LocationUtilization')
const YieldPrices = () => import('@/components/Yield/Prices')
const YieldSpaceUtilization = () =>
  import('@/components/Yield/SpaceUtilization')

const ModalYieldPlayground = () =>
  import('@/components/Yield/Playground/ModalYieldPlaygrounds')

export default {
  components: {
    'yield-day-percentages': YieldDayPercentages,
    'yield-group-sizes': YieldGroupSizes,
    'yield-location-utilization': YieldLocationUtilization,
    YieldPrices,
    'yield-space-utilization': YieldSpaceUtilization,

    'modal-yield-playgrounds': ModalYieldPlayground,
  },

  data() {
    return {
      locationId: Number(this.$route.params.locationId),
      showYieldPlayground: false,
      yieldId: Number(this.$route.params.yieldId),
    }
  },

  computed: {
    ...mapState('locationStore', ['locationState']),
    ...mapState('yieldStore', ['yieldSettingsState']),
  },

  async created() {
    !this.locationState && (await this.getLocationState(this.locationId))

    if (!this.yieldSettingsState) {
      this.getYieldSettings()
    }
  },

  beforeDestroy() {
    this.setYieldSettingsState({
      yieldSettings: null,
    })
  },

  methods: {
    ...mapMutations('yieldStore', ['setYieldSettingsPlayground']),
    ...mapMutations('yieldStore', ['setYieldSettingsState']),
    ...mapActions('locationStore', ['getLocationState']),

    getYieldSettings() {
      let self = this

      yieldProvider.methods
        .getYieldSeetingsById(self.yieldId)
        .then((response) => {
          if (response.status === 200) {
            this.setYieldSettingsState({
              isSaving: false,
              isSavingSuccess: false,
              isSavingError: false,
              yieldSettings: response.data,
            })

            self.setYieldSettingsState(this.setYieldSettingsState)

            self.onClickCancel()
          }
        })
        .catch((error) => {
          self.isSavingError = true
        })
        .finally(() => {
          self.isSaving = false
        })
    },

    setShowYieldPlayground() {
      this.showYieldPlayground = true

      let yieldSettings = JSON.parse(
        JSON.stringify(this.yieldSettingsState.yieldSettings)
      )
      this.setYieldSettingsPlayground(yieldSettings)
    },

    closeEditModal() {
      this.showYieldPlayground = false
    },
  },
}
</script>

<style lang="scss">
.box {
  height: 100%;
}
</style>